import { useQuery } from '@tanstack/react-query';
import type { HealthStatus } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

/** Polls the API /health endpoint — powers the status page + down-detection. */
export function useHealth() {
  return useQuery<HealthStatus>({
    queryKey: ['health'],
    queryFn: () => apiFetch<HealthStatus>('/health'),
    refetchInterval: 30_000,
    retry: 2,
    retryDelay: 1500,
  });
}
